/**
 * Chip do prazo prometido (tabela, kanban, detalhe). Cor só comunica
 * estado: info = no prazo, warning = vence hoje, danger = vencido/atrasado,
 * success = entregue no prazo. Sem prazo: não renderiza.
 */
import React from "react";

import { descreverPrazo } from "./prazo";
import { Pill } from "./styles";

export default function PrazoChip({ solicitacao, style, bloco = false }) {
  const p = descreverPrazo(solicitacao);
  if (!p) return null;
  const chip = (
    <Pill $tone={p.tone} title={p.titulo} style={style}>
      {p.texto}
    </Pill>
  );
  // `bloco`: linha própria (célula de tabela com ellipsis cortaria o chip).
  return bloco ? <div style={{ marginTop: 4 }}>{chip}</div> : chip;
}
